var render, staticRenderFns
import script from "./NsDynamicHtml.vue?vue&type=script&lang=js&"
export * from "./NsDynamicHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94542ad2')) {
      api.createRecord('94542ad2', component.options)
    } else {
      api.reload('94542ad2', component.options)
    }
    
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsDynamicHtml.vue"
export default component.exports